import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { LoginContext } from '../reactcontext/ReactContext'
import landingImg from '../assets/landing page.jpg'
import Logo from '../assets/logo.avif'
import { Logout } from '../components'


const Welcome = () => {
  const { loginInfo, } = useContext(LoginContext)

  return (
    <div className='w-full h-full flex relative'>
      <img src={landingImg} alt="landing Img" className='w-full h-[100vh]' />
      
      <div className='absolute h-full w-full flex flex-col justify-center items-center bg-black bg-opacity-40 z-10'>
        <div className='md:text-[18pt] text-[16pt] my-[15px] mx-6 flex flex-col items-center gap-4'>
          {/* Logo */}
          <img src={Logo} alt="LOGO" className='w-16 h-16 md:w-20 md:h-20' />
          
          {
            !loginInfo.login ? 
              <div className='flex flex-col items-center gap-4'>
                <div>
                  <h1 className='text-white text-4xl'>Hi! ~Rahman Group~</h1>
                </div>
                <div className='animate-pulse shadow-xl rounded-2xl bg-transparent p-4 flex items-center justify-center gap-4'>
                  <Link to={'/login'} className='bg-blue-600 text-dimWhite p-2 px-4 rounded-lg shadow-xl'>Login</Link>
                  {/*<Link to={'/register'} className='bg-yellow-500 p-2 px-4 rounded-lg shadow-xl'>Register</Link>*/}
                </div>
              </div> 
              : <div className='text-dimWhite p-3 flex flex-col gap-y-3'>
                <p>
                  Welcome {' - '}
                  <span className='font-bold'>
                    {loginInfo.userDetails.firstName}
                  </span>
                </p>

                <Link to={'/dashboard'} className='text-yellow-400 opacity-50 shadow-lg rounded-lg border-2 border-x-yellow-300 border-y-white px-3 py-1'>
                  Get Started
                </Link>

                <Logout />

              </div>
          }
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className='absolute bottom-0 left-0 right-0 flex justify-center pb-4 md:pb-6 z-20'>
        <p className='text-white text-xs md:text-sm text-center'>
          © 2026 Rahman Group. All rights reserved.
        </p>
      </div>
      
    </div>
  )
}

export default Welcome
